import {createAction, props} from '@ngrx/store';
import {CollectionItem} from '../collection-item.model';
import {Location} from '../../location/location.model';

const action = '[CollectionItem]'
export const loadCollectionItem = createAction(`${action} - Load collectionItem`, props<{ collectionItemId: string }>())
export const loadCollectionItemSuccess = createAction(`${action} - Load collectionItem success`, props<{
  collectionItem: CollectionItem
}>())
export const loadCollectionItemError = createAction(`${action} - Load collectionItem error`)
export const identifyCollectionItem = createAction(`${action} - Identify collectionItem`, props<{ code: string }>())
export const addCollectionItem = createAction(`${action} - Add collectionItem to collection`, props<{
  collectionItem: CollectionItem;
  collectionId?: string;
  location?: Location
}>())


export const deleteCollectionItem = createAction(`${action} - Delete collectionItem`, props<{
  collectionItemId: string
}>())

export const deleteCollectionItemAborted = createAction(`${action} - Delete collectionItem aborted`)
export const deleteCollectionItemSuccess = createAction(`${action} - Delete collectionItem success`)
export const deleteCollectionItemError = createAction(`${action} - Delete collectionItem error`)

export const confirmDeleteCollectionItem = createAction(
  `${action} - Confirm delete collectionItem`,
  props<{ collectionItemId: string }>()
);

export const verifyWarranty = createAction(`${action} - Verify warranty`, props<{ collectionItemId: string }>());
export const verifyWarrantySuccess = createAction(
  `${action} - Verify warranty success`,
  props<{ collectionItemId: string }>()
);
export const verifyWarrantyMissingAddress = createAction(`${action} - Verify warranty missing address`, props<{ collectionItemId: string }>());
export const userNotAllowedToExtendWarranty = createAction('[Warranty] User Not Allowed to Extend Warranty');
export const userCanceledWarranty = createAction('[Warranty] User Canceled');
export const verifyWarrantyFailed = createAction('[Warranty] Verify Warranty Failed');

export const extendWarranty = createAction(`${action} - Extend warranty`, props<{ collectionItemId: string, policyId: number }>());
export const extendWarrantySuccess = createAction(`${action} - Extend warranty success`, props<{ collectionItemId: string }>());
export const extendWarrantyError = createAction(`${action} - Extend warranty error`, props<{ error: any }>());

export const reloadCollectionItem = createAction(
  '[CollectionItem] Reload Collection Item',
  props<{ collectionItemId: number }>()
);
